import React from 'react';
import { RefreshCw } from 'lucide-react';

interface LoadingSpinnerProps {
	size?: 'sm' | 'md' | 'lg';
	className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'md', className = '' }) => {
	const sizeClasses = {
		sm: 'h-4 w-4',
		md: 'h-8 w-8',
		lg: 'h-12 w-12',
	};

	return (
		<div className={`flex items-center justify-center ${className}`}>
			<RefreshCw className={`animate-spin text-blue-600 ${sizeClasses[size]}`} />
		</div>
	);
};
